import MatchBasicModel from "../../../Football/Models/Match/MatchBasicModel";

export default class GameResultsModel {
    public matchId: string = null;
    public matchModel: MatchBasicModel = null;
    public outcome: string = null;
}